<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_store"
            :items="stores_of"
            item-text="name"
            item-value="id"
            label=" أختر المخزن "
            persistent-hint
            return-object
            single-line
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-btn @click="gardStore"> جرد مخزن</v-btn>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="asnaf"
        class="elevation-1"
        v-if="asnaf.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-right">{{ props.item.item.name }}</td>
          <td class="text-xs-right">{{ props.item.quantity }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد اصناف متاحة</div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  clients,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  stores_of,
  khazina,
  khazna_fatworas,
  asnaf,
  moneys,
  gardStore,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      { text: " الصنف", value: "address", sortable: false, align: "right" },
      { text: "  العدد", value: "rasid", sortable: false, align: "right" }
    ],
    select_client: { id: "" },
    select_store: { id: "" },
    select_money: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    asnaf: [],
    moneys: [],
    clients: [],
    fatworas: [],
    stores_of: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    emp_to: "",
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",

    khazna_fatwora_table: {
      code: "",
      emp_name: "",
      rasid_before: "",
      money: "",
      rasid_after: "",
      type: "",
      notes: "",
      khazina_id: ""
    },

    khazina_update: {
      id: "",
      rasid: ""
    },
    money_fatwora: {
      code: "",
      money_q: "",
      emp_responsible_name: "",
      emp_name_to: "",
      notes: "",
      money_id: "",
      emp_id: ""
    }
  }),

  computed: {},

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    stores_of().then(response => {
      this.stores_of = response.data.stores;
      this.loading = false;
    });
  },

  methods: {
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    gardStore() {
      gardStore(this.select_store.id).then(response => {
        this.asnaf = response.data;
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
